module.exports = __webpack_public_path__ + "media/pricing/Paid_Faster-7e9fa047.svg";